import PositionsTable from './PositionsTable';

export default PositionsTable;
